
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"walkablePlugin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LearnerWalkable"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"plugin"},"directives":[]}]}}]}}],"loc":{"start":0,"end":101}};
    doc.loc.source = {"body":"#import './plugin.gql'\n\nfragment walkablePlugin on LearnerWalkable {\n  plugin {\n    ...plugin\n  }\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./plugin.gql').definitions));


      module.exports = doc;
    
